//Figma: https://www.figma.com/file/opwtTydjDhauMwE5LPggjt/Landing-Page-%E8%90%BD%E5%9C%B0%E9%A1%B5?type=design&node-id=708%3A508&mode=design&t=dylsjguhlgAEYNgl-1

import { ReactElement, useEffect, useMemo, useState } from 'react'
import { GetStaticPropsContext } from 'next'
import Script from 'next/script'
import Image from 'next/image'
import { useTranslations } from 'next-intl'
import Link from 'next/link'
import { useRouter } from 'next/router'
import * as Yup from 'yup'
import toast, { Toaster } from 'react-hot-toast'

import { NextPageWithLayout } from '../../common/common-types'
import retriveMessages, { LocaleType } from '../../messages/message'
import FullPageLayout from '../../components/full-page-layout/full-page-layout'

import PdForm, { FieldItem } from '../../components/pd-atom-form/pd-atom-form'
import { UseFormGetValues, UseFormTrigger, FieldValues } from 'react-hook-form'
import { withSEO } from '../../common/with-seo'
import { submitForm } from '../../service/form.service'

const Scenes: { name: string; img: string }[] = [
  { name: 'オフィスビル', img: 'https://cdn.pudutech.com/official-website/ad/jp-cc1-cases/01.png' },
  { name: '教育機関 ', img: 'https://cdn.pudutech.com/official-website/ad/jp-cc1-cases/02.png' },
  { name: '小売業界 ', img: 'https://cdn.pudutech.com/official-website/ad/jp-cc1-cases/03.png' },
  { name: '飲食店', img: 'https://cdn.pudutech.com/official-website/ad/jp-cc1-cases/04.png' },
  { name: '公共交通機関', img: 'https://cdn.pudutech.com/official-website/ad/jp-cc1-cases/05.png' },
  { name: '介護・医療機関', img: 'https://cdn.pudutech.com/official-website/ad/jp-cc1-cases/06.png' },
  { name: '工場', img: 'https://cdn.pudutech.com/official-website/ad/jp-cc1-cases/07.png' },
  { name: '住宅', img: 'https://cdn.pudutech.com/official-website/ad/jp-cc1-cases/08.png' },
]

const Specification: [string, string][][] = [
  [
    ['本体寸法', '663*568*682mm'],
    ['清掃効率', 'スクラブ：3時間～4時間<br/>スイープ＋バキューム：4時間～５時間<br/>モップ：8時間 '],
  ],
  [
    ['本体重量', '75kg'],
    ['運転音', '700～1000m²/h'],
  ],
  [
    ['掃き幅', '500mm'],
    ['走行速度', '70dB未満 '],
  ],
  [
    ['こすり幅', '400mm'],
    ['走行速度', '0.2m/s ～1.2m/s '],
  ],
  [
    ['水タンク容量', '上水タンク 15L<br/>排水タンク 15L '],
    ['タッチパネル', '10.1インチ '],
  ],
  [
    ['運転時間 ', '3時間'],
    ['位置決め方法', 'ビジュアル+レーザーポジショニング'],
  ],
]

const OverviewContentList = {
  title: '概要',
  messages: [
    ['キャペーン名', 'PuduCC1　無料お試しキャンペーン'],
    ['施行期間', '2023年５月22日—2023年12月31日'],
    ['内容', 'ご希望の施設・店舗に無料で「CC1」最大１台を1~7日間導入いただけます。（施設・店舗によって異なります）'],
    [
      '対象のお客様',
      '施設・店舗（飲食店、ホテル、介護施設、レジャー施設、小売店、スーパー、病院、量販店など）のオーナー様(※店舗の環境によっては制限あり)',
    ],
    [
      '適用条件',
      '• 1店舗につき最大1台まで（屋内で利用すること）<br/>• 申込期間中にお申込みフォームよりお申し込み手続きを行っていただく必要があります。<br/>• 詳細は相談可能です。',
    ],
  ],
}

const AttentionMessage = {
  title: '注意事項',
  messages: [
    [
      '',
      [
        '• お申し込みは、日本国内の法人に限ります。',
        '• お申し込み状況によりトライアル期間が遅れる可能性がありますが、キャンペーン期間中にお申込みいただいた方は特典の対象となります。',
        '• お申し込みは、1店舗1回限りとさせていただきます。重複してお申し込みされた場合は、無効とさせていただきます。',
        '• 当社からの連絡後、5営業日以内にご返答いただけない、もしくはお申込みフォームにてご記入いただいたご連絡先・メールアドレスに誤りがあり、ご連絡がつかない場合、本キャンペーンの特典実施を見送る場合がございます。',
        '• ヒアリング後に実施条件が折り合わない場合、本キャンペーンの特典実施を見送る場合があります。',
        '• お申込内容に虚偽がある場合、法人名等を偽ってお申込みされた場合、当社の判断でキャンペーンの対象から除外いたします。',
        '• 設置費用、搬送費などが発生する場合もあります。',
        '• ロボットの利用中の動画や画像をご提供いただければ幸いです。（お試しキャンペーンの優先順位となります）',
        '※その画像や動画をネット上で公開する事に同意していただく事が条件となります。',
        '• お客様の故意または過失による機体の毀損が確認された場合は、修理費用を請求させていただく場合があります。',
        '• 公序良俗に反する行為や、不正応募、明らかな商業行為などが認められる場合には、当社の判断で本キャンペーンの対象から除外いたします。',
        '• 本キャンペーンの解釈権はPudu Roboticsが所有します。内容・期間は予告なく変更する場合がありますので、あらかじめご了承ください。',
        '• 本キャンペーンに関する全てのお問い合わせは、global_sales@pudutech.comまでご連絡ください。',
      ].join('<br/>'),
    ],
  ],
}

const FormFields: FieldItem[] = [
  { type: 'INPUT', label: '会社名', fieldName: 'companyName', placeholder: 'ご記入願います', rule: { required: true } },
  { type: 'INPUT', label: '氏名', fieldName: 'name', placeholder: 'ご記入願います', rule: { required: true } },
  {
    type: 'INPUT',
    label: 'メールアドレス',
    fieldName: 'email',
    placeholder: 'ご記入願います',
    rule: { required: true },
  },
  {
    type: 'INPUT',
    label: '電話番号',
    fieldName: 'phoneNumber',
    placeholder: 'ご記入願います',
    rule: { required: true },
  },
  {
    type: 'INPUT',
    label: '都道府県',
    fieldName: 'prefectures',
    placeholder: 'ご記入願います',
    rule: { required: true },
  },
  {
    type: 'INPUT',
    label: '店舗住所',
    fieldName: 'shopAddress',
    placeholder: 'ご記入願います',
    rule: { required: true },
  },
  { type: 'INPUT', label: '業種', fieldName: 'industry', placeholder: 'ご記入願います', rule: { required: true } },
  {
    type: 'INPUT',
    label: '役職',
    fieldName: 'officialPosition',
    placeholder: 'ご記入願います',
    rule: { required: true },
  },
  {
    type: 'INPUT',
    label: '店舗数・施設数',
    fieldName: 'storesNumber',
    placeholder: 'ご記入願います',
    rule: { required: true },
  },
  {
    type: 'INPUT',
    label: '導入開始希望日',
    fieldName: 'installationDate',
    placeholder: 'ご記入願います',
    rule: { required: true },
  },
  { type: 'TEXT', label: 'メーセージ', fieldName: 'message', placeholder: 'ご記入願います', rule: { required: false } },
]

const JPCC1: NextPageWithLayout = () => {
  const t = useTranslations()
  const router = useRouter()
  const [agree, setAgree] = useState(0)
  const [isMobile, setIsMobile] = useState(false)
  const [messageIndex, setMessageIndex] = useState(0)

  const manualMessage = useMemo(() => {
    const validMessages = [OverviewContentList, AttentionMessage]
    return validMessages[messageIndex]
  }, [messageIndex])

  function handleSubmit(values: FieldValues) {
    const payload = {
      company: values.companyName,
      name: values.name,
      email: values.email,
      mobile: values.phoneNumber,
      province: values.prefectures,
      address: values.shopAddress,
      careerBackground: values.industry,
      jobTitle: values.officialPosition,
      remark: `门店数：${values.storesNumber}; 希望使用时间:${values.installationDate}; 用户留言： ${values.message}`,
      countryCode: 'JP',
    }

    if (values['PHONE_NUMBER']) {
      // @ts-ignore
      payload['PHONE_NUMBER'] = values['PHONE_NUMBER']
    }

    if (values['E_MAIL']) {
      // @ts-ignore
      payload['E_MAIL'] = values['E_MAIL']
    }

    submitForm(payload)
      .then((res) => {
        if (res.code === 200 || res.code === 0) {
          router.push(
            {
              pathname: '/contact-us/success',
              query: {
                email: values.email,
                phone: values.mobile,
                name: values.name,
                formId: 'jpcc1',
              },
            },
            '/contact-us/success'
          )
        } else {
          const error = res.message
          toast.error(error)
        }
      })
      .catch((res) => {
        const response = res.response.data
        const error = response.message
        toast.error(error)
      })
  }

  useEffect(() => {
    setIsMobile(window.innerWidth <= 1200)
  }, [])

  return (
    <>
      <Script id="gsap" src="/libs/gsap.min.js" />
      <Script
        id="scroll-trigger"
        src="/libs/ScrollTrigger.min.js"
        strategy="lazyOnload"
        onLoad={() => {
          if (window.innerWidth < 1200) {
            return
          }

          //@ts-ignore
          gsap.registerPlugin(ScrollTrigger)

          const xTo = gsap.quickTo('#scenes-list', 'x', { duration: 0.1, ease: 'slow' })

          //@ts-ignore
          gsap.timeline({
            smoothChildTiming: true,
            scrollTrigger: {
              scroller: '#main',
              trigger: '#scenes-section',
              pin: true,
              start: 'bottom bottom',
              end: '+=100%',
              scrub: true,
              pinType: 'fixed',
              onUpdate: (self: { progress: number }) => {
                console.log('onUpdate: ', self.progress)
                const scenesListEle = document.getElementById('scenes-list')
                const featureSectionInnerEle = document.getElementById('feature-section-inner')

                if (scenesListEle) {
                  const viewportWidth = window.innerWidth
                  const distance = Math.max(scenesListEle.scrollWidth - viewportWidth, 0)
                  xTo(0 - distance * self.progress)
                }
              },
            },
          })

          // @ts-ignore
          ScrollTrigger.create({
            scroller: '#main',
            trigger: '#scenes-section',
            pin: '#feature-section',
            start: 'bottom bottom',
            end: '+=100%',
            pinSpacing: false,
            pinType: 'fixed',
          })
        }}
      />

      <div className="w-full relative">
        {/* header page */}
        <section
          className={[
            'relative flex flex-col w-full max-w-screen mx-auto',
            'h-[158.5vw] bg-jpCC1H5Banner',
            'laptop:bg-jpCC1Banner bg-[length:100vw_100%] bg-no-repeat laptop:flex-row laptop:justify-between laptop:h-[54.6vw] laptop:max-h-[1528px] laptop:max-w-[2800px] ',
          ].join(' ')}
        >
          <div className="absolute left-3 top-3 laptop:left-8 laptop:top-8 z-10 cursor-pointer">
            <Link href="/">
              <Image
                alt="head"
                src={'https://cdn.pudutech.com/official-website/ad/jp-cc1-head.svg'}
                width={isMobile ? 305 : 442}
                height={isMobile ? 25 : 34}
              />
            </Link>
          </div>
        </section>

        <section id={'feature-section'} className="py-15 laptop:pt-30 laptop:pb-113px w-full">
          <div id="feature-section-inner" className="px-6 laptop:px-0 max-w-full w-300 mx-auto text-center">
            <h3 className="text-24 laptop:text-48 text-black/90 font-bold">{t('cc1_ad_section1_title')}</h3>
            <div
              className={[
                'flex',
                'flex-col mt-8 gap-y-6',
                'laptop:flex-row laptop:justify-between laptop:mt-15 laptop:gap-x-4 laptop:gap-y-0',
              ].join(' ')}
            >
              <div className="p-4 laptop:p-8 border border-[#97c92e] rounded-xl flex flex-col items-start flex-1">
                <Image
                  alt="icon"
                  src="https://cdn.pudutech.com/official-website/ad/jp-cc1-icon1.svg"
                  width="70"
                  height="70"
                  className="!w-15 !h-15 !laptop:w-70px !laptop:h-70px"
                />
                <h3 className="text-18 laptop:text-24 text-black/90 font-bold mt-4 laptop:mt-8">
                  ①スタッフの業務負担が大きい
                </h3>
                <p className="text-sm laptop:text-base text-black/60 font-normal mt-3 laptop:mt-6 text-left tracking-widest">
                  スイープ、床洗浄、吸引、乾拭きの多様な機能を１台に集約する
                </p>
                <p className="text-sm laptop:text-base text-black/60 font-normal mt-3 laptop:mt-6 text-left tracking-widest">
                  １台のロボットで、あらゆる清掃ニーズに十分に対応できる
                </p>
              </div>
              <div className="p-4 laptop:p-8 border border-[#97c92e] rounded-xl flex flex-col items-start flex-1">
                <Image
                  alt="icon"
                  src="https://cdn.pudutech.com/official-website/ad/jp-cc1-icon2.svg"
                  width="70"
                  height="70"
                />
                <h3 className="text-18 laptop:text-24 text-black/90 font-bold mt-4 laptop:mt-8">②清掃業務の効率化</h3>
                <p className="text-sm laptop:text-base text-black/60 font-normal mt-3 laptop:mt-6 text-left tracking-widest">
                  人工清掃の24ｈ＝<span className="text-[#97c92e] font-bold">5h（有効清掃時間）</span>
                  ＋3h（無効清掃時間）＋16h（退勤時間）
                </p>
                <p className="text-sm laptop:text-base text-black/60 font-normal mt-3 laptop:mt-6 text-left tracking-widest">
                  CC１の24h＝
                  <span className="text-[#97c92e] font-bold">
                    5h（清掃業務）＊自動充電/自動給排水（一日中３回作業可能）
                  </span>
                </p>
              </div>
            </div>

            <div
              className={[
                'relative flex justify-center items-center bg-[url("https://cdn.pudutech.com/official-website/ad/jp-cc1-img-circle.svg")] bg-no-repeat bg-center',
                'mt-8 w-full px-6 h-1037px flex-col bg-contain',
                'laptop:w-full laptop:px-0 laptop:h-900px laptop:mt-113px laptop:flex-row',
              ].join(' ')}
            >
              <Image
                alt="cc1 logo"
                src="https://cdn.pudutech.com/official-website/ad/jp-cc1-img2.jpg"
                width={isMobile ? '230' : '540'}
                height={isMobile ? '230' : '540'}
              />

              <div
                className={[
                  'absolute left-0  bg-[#97c92e] text-left',
                  'p-3 rounded-lg top-0 h-197px w-full',
                  'laptop:rounded-3xl laptop:w-fit laptop:p-6 laptop:top-47px laptop:h-fit',
                ].join(' ')}
              >
                <h5 className="text-black/90 text-18 laptop:text-20 font-bold mb-3 laptop:mb-4 leading-none">
                  自動＆手動簡単切り替え
                </h5>
                <Image
                  alt="img"
                  src="https://cdn.pudutech.com/official-website/ad/jp-cc1-img3.svg"
                  width={isMobile ? '303' : '341'}
                  height={isMobile ? '140' : '158'}
                  layout={isMobile ? 'responsive' : 'intrinsic'}
                />
              </div>

              <div
                className={[
                  'absolute right-0 bg-[#97c92e]  text-left',
                  'p-3 rounded-lg top-209px h-197px w-full',
                  'laptop:rounded-3xl laptop:w-fit laptop:p-6 laptop:top-0 laptop:h-fit',
                ].join(' ')}
              >
                <h5 className="text-black/90 text-18 laptop:text-20 font-bold mb-3 laptop:mb-4 leading-none">
                  隅々にぴったりフィット
                </h5>
                <Image
                  alt="img"
                  src="https://cdn.pudutech.com/official-website/ad/jp-cc1-img4.png"
                  width={isMobile ? '303' : '341'}
                  height={isMobile ? '140' : '158'}
                  layout={isMobile ? 'responsive' : 'intrinsic'}
                />
              </div>
              <div
                className={[
                  'absolute right-0  bg-[#97c92e] text-left',
                  'p-3 rounded-lg bottom-0 h-197px w-full',
                  'laptop:rounded-3xl laptop:p-6 laptop:w-auto laptop:bottom-47px laptop:h-fit',
                ].join(' ')}
              >
                <h5 className="text-black/90 text-18 laptop:text-20 font-bold mb-3 laptop:mb-4 leading-none">
                  各床材に対応
                </h5>
                <Image
                  alt="img"
                  src="https://cdn.pudutech.com/official-website/ad/jp-cc1-img5.png"
                  width={isMobile ? '303' : '341'}
                  height={isMobile ? '140' : '158'}
                  layout={isMobile ? 'responsive' : 'intrinsic'}
                />
              </div>

              <div
                className={[
                  'absolute left-0 bg-[#97c92e] text-left ',
                  'p-3 rounded-lg bottom-209px h-197px w-full',
                  'laptop:rounded-3xl laptop:p-6 laptop:w-auto laptop:bottom-0 laptop:h-fit',
                ].join(' ')}
              >
                <h5 className="text-black/90 text-18 laptop:text-20 font-bold mb-3 laptop:mb-4 leading-none">
                  4in1多用途清掃
                </h5>
                <p
                  className={[
                    'bg-[#f4ffd4]   font-normal',
                    'p-3 w-303px h-35 text-14 rounded-lg ',
                    'laptop:p-4 laptop:w-340px laptop:h-158px laptop:text-base laptop:rounded-xl',
                  ].join(' ')}
                >
                  一台のロボットに多様な清掃機能を搭載、清掃課題に対して各アクセサリーの切り替えで対応可能。
                </p>
              </div>
            </div>
          </div>
        </section>

        <section
          id={'scenes-section'}
          className={[
            'relative w-full bg-[#f4ffd4] overflow-hidden transition-none pointer-events-none',
            'py-15',
            'laptop:py-30',
          ].join(' ')}
        >
          <h2 className="w-full text-center text-24 laptop:text-48 text-black/90 font-bold">
            様々なシナリオに対応可能
          </h2>
          <ul
            id="scenes-list"
            className={[
              'w-screen flex flex-row transition-transform duration-500 will-change-transform',
              'mt-8 pl-0 gap-x-5 gap-y-10 flex-wrap justify-center',
              'laptop:mt-16 laptop:pl-90 laptop:gap-x-10 laptop:flex-nowrap laptop:justify-start',
            ].join(' ')}
          >
            {Scenes.map((scene) => (
              <li key={scene.name} className="text-center shrink-0">
                <Image
                  alt={scene.name}
                  src={scene.img}
                  width={isMobile ? '158' : '268'}
                  height={isMobile ? '158' : '268'}
                  className={isMobile ? 'rounded-xl' : 'rounded-3xl'}
                />
                <h5 className="mt-3 laptop:mt-9 text-14 laptop:text-20 text-black/90 font-bold">{scene.name}</h5>
              </li>
            ))}
          </ul>
        </section>

        <section className="relative w-full pt-15 laptop:pt-30 pb-15 laptop:pb-214px bg-white text-center px-8 laptop:px-0">
          <h3 className="text-24 laptop:text-48 text-black/90 font-bold">清掃のデジタル化</h3>
          <p className="text-sm laptop:text-base text-black/60 font-normal mt-3 laptop:mt-6">
            ・アプリを使ったリモート操作により、作業状態をいつでもチェック可能
          </p>
          <p className="text-sm laptop:text-base text-black/60 font-normal mt-3 laptop:mt-0">
            ・清掃時間や清掃面積など、清掃実績のリアルタイム通知を送信
          </p>
          <p className="text-sm laptop:text-base text-black/60 font-normal mt-3 laptop:mt-0">
            ・清掃効果のデジタル化とビジュアル化：各ユニットの作業状態を収集・要約して、清掃レポートを自動生成
          </p>

          <div className="flex flex-row justify-center max-w-full w-300 mx-auto mt-8 laptop:mt-16">
            <Image
              alt="dashboard1"
              src="https://cdn.pudutech.com/official-website/ad/jp-cc1-dashboard.png"
              width={isMobile ? '327' : '1130'}
              height={isMobile ? '189' : '654'}
              quality={100}
            />
          </div>
        </section>

        <section className="bg-[#f4ffd4] text-center py-15 laptop:pt-70px laptop:pb-136px">
          <h3 className="text-24 laptop:text-48 font-bold text-black/90">PUDU CC1 スペック紹介</h3>
          <div className="mt-3 laptop:mt-90px flex flex-col laptop:flex-row max-w-full w-300 mx-auto">
            <div className="flex-1">
              <Image
                alt="cc1 robot"
                src="https://cdn.pudutech.com/official-website/ad/jp-cc1-logo.png"
                width={isMobile ? '250' : '500'}
                height={isMobile ? '250' : '500'}
              />
            </div>

            <div className="flex-1 px-6 laptop:px-0 space-y-3 laptop:space-y-0">
              {Specification.map((spec, index) => (
                <div
                  key={index}
                  className="flex flex-col laptop:flex-row w-full laptop:w-148 laptop:py-4 laptop:border-b border-[#97c92e] text-left laptop:gap-x-6 gap-y-3"
                >
                  <div className="flex-1 text-sm laptop:text-base font-normal border-b border-[#97c92e] laptop:border-0 pb-3 laptop:pb-0">
                    <p className="text-black/60 mb-1 laptop:mb-2">{spec[0][0]}</p>
                    {spec[0][1].split('<br/>').map((text) => (
                      <p key={text} className="text-black/90 text-12 laptop:text-base">
                        {text}
                      </p>
                    ))}
                  </div>

                  <div className="flex-1 text-sm laptop:text-base font-normal border-b border-[#97c92e] laptop:border-0 pb-3 laptop:pb-0">
                    <p className="text-black/60 mb-1 laptop:mb-2">{spec[1][0]}</p>
                    {spec[1][1].split('<br/>').map((text) => (
                      <p key={text} className=" text-12 laptop:text-base text-black/90">
                        {text}
                      </p>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="relative w-full h-fit box-border before:absolute before:top-0 before:block before:content-[''] before:w-full before:h-410px laptop:before:h-150 before:bg-[#97c92e]">
          <div className="relative flex flex-col items-center laptop:justify-center laptop:items-start laptop:flex-row max-w-full w-full mx-auto">
            <div className="mt-15 laptop:mt-30 w-full laptop:w-390px text-center laptop:text-left">
              <h3 className="text-24 laptop:text-5xl text-black/90 font-bold mb-4 laptop:mb-6">
                無料お試しはこちらから
              </h3>
              {!isMobile && (
                <Image
                  alt="arrow icon"
                  src="https://cdn.pudutech.com/official-website/ad/jp-cc1-arrow.png"
                  width="78"
                  height="28"
                />
              )}
            </div>

            <div className="w-326px laptop:w-fit flex flex-col gap-y-4 laptop:gap-y-6 p-4 laptop:p-8 rounded-xl laptop:rounded-3xl text-18 laptop:text-20 text-black/90 bg-white mt-8 laptop:mt-30 laptop:ml-16 border border-[#97c92e]">
              <h5>{manualMessage.title}</h5>
              {manualMessage.messages.map((item, index) => (
                <div key={index} className="w-full laptop:w-680px text-sm laptop:text-base">
                  {item[0] && <h5>{item[0]}</h5>}
                  {item[1].split('<br/>').map((entry) => (
                    <p className="text-black/60 mt-1" key={entry}>
                      {entry}
                    </p>
                  ))}
                </div>
              ))}

              <button
                className="self-end flex items-center mt-6 laptop:mt-12 bg-[#97c92e] rounded-full w-fit px-3 laptop:px-6 py-1 laptop:py-2 text-12 laptop:text-base text-black/90 gap-x-6px laptop:gap-x-2"
                onClick={() => setMessageIndex((messageIndex + 1) % 2)}
              >
                {messageIndex === 1 && (
                  <Image
                    alt="pre"
                    src="https://cdn.pudutech.com/official-website/ad/button-arrow-pre.svg"
                    width={isMobile ? 16 : 22}
                    height={isMobile ? 8 : 10}
                  />
                )}
                <span>次のページ</span>
                {messageIndex === 0 && (
                  <Image
                    alt="next"
                    src="https://cdn.pudutech.com/official-website/ad/jp-cc1-button-arrow.svg"
                    width={isMobile ? 16 : 22}
                    height={isMobile ? 8 : 10}
                  />
                )}
              </button>
            </div>
          </div>
        </section>

        <section className="w-full bg-white pt-15 laptop:pt-30 pb-30 px-6 laptop:px-0">
          <Toaster />
          <div
            id="form"
            className="max-w-full laptop:pt-30 w-300 mx-auto flex flex-col laptop:flex-row justify-between"
          >
            <h3 className="w-full text-center  laptop:text-left laptop:w-390px text-22 laptop:text-5xl text-black/90 font-bold">
              資料請求・お申し込みはこちら
            </h3>
            <div className="max-w-full w-744px mt-8 laptop:mt-0">
              <div className="w-full border-b border-[#c2c2c2] mb-8 laptop:mb-12 pb-3 laptop:pb-6 ">
                <p className="text-18 laptop:text-24 text-black/90">Pudu CC1無料お試しキャンペーンお申し込み</p>
                <p className="text-sm laptop:text-base text-black/60 mt-3 laptop:mt-2">
                  お客様の情報はセキュリティで保護されています。安心してご利用ください。
                </p>
              </div>
              <PdForm
                fields={FormFields}
                onSubmit={handleSubmit}
                bottomRender={(trigger, getValues, formState, formValidity) => {
                  return (
                    <div className="mt-0">
                      <div className="flex flex-row gap-x-4">
                        <input
                          name="agree"
                          type="checkbox"
                          value={agree}
                          onChange={() => setAgree((prev) => 1 - prev)}
                        />
                        <p className="text-12 laptop:text-sm text-black/60">
                          Pudu Roboticsは、お客様のプライバシーを保護し、尊重することをお約束します。
                          [送信]をクリックすると、Pudu Roboticsのプライバシーポリシーを読み、同意したことになります。
                          Pudu
                          Roboticsは、お客様の情報を使用して、更新や特別オファーについてお客様に連絡する場合があります。
                          いつでも退会できます。
                        </p>
                      </div>
                      <p className="text-12 laptop:text-sm text-[#f76719] mt-6 laptop:mt-12">
                        ※ご連絡先メールアドレス宛にお申し込み内容の控えをメールで送信します。メールアドレスの間違いが非常に多いので、再度ご確認お願い致します。
                      </p>

                      <input
                        className={[
                          'mt-8 laptop:mt-12 w-full laptop:w-fit laptop:px-76px py-13px laptop:py-18px rounded-full  text-white text-base laptop:text-xl cursor-pointer',
                          agree && formValidity ? 'bg-[#92c92e]' : 'bg-d8',
                        ].join(' ')}
                        type="submit"
                        disabled={!(agree && formValidity)}
                        value="申し込み"
                      />
                    </div>
                  )
                }}
              />
            </div>
          </div>
        </section>
      </div>

      <div className="fixed scale-50 laptop:scale-100 -right-4 bottom-0 laptop:right-16 laptop:bottom-16 z-50">
        <Link href="#form">
          <div>
            <div className="flex justify-center items-center w-31 h-31 border-2 border-[#97c92e] rounded-full bg-white">
              <img alt="cc1" src="https://cdn.pudutech.com/official-website/ad/cc1bot.png" className="-mt-10px" />
            </div>
            <button className="w-31 h-11 rounded-full bg-[#97c92e] text-18 font-bold text-white -translate-y-10">
              Contact Us
            </button>
          </div>
        </Link>
      </div>
    </>
  )
}

export const getStaticProps = withSEO(
  async ({ locale }: GetStaticPropsContext) => {
    const messages = retriveMessages(['ads'], locale as LocaleType)

    return {
      props: {
        messages,
      },
      revalidate: 60,
    }
  },
  () => '/ads/jp-cc1'
)

JPCC1.getLayout = function (page: ReactElement, seo) {
  return (
    <FullPageLayout
      pageTitle={'PUDU CC1'}
      pageDescription={seo.description}
      pageKeywrods={seo.keywords}
      ogtype={'website'}
    >
      {page}
    </FullPageLayout>
  )
}

export default JPCC1
